var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.90332C7.92826 0.90332 8.8185 1.27207 9.47487 1.92845C10.1313 2.58482 10.5 3.47506 10.5 4.40332C10.5 5.33158 10.1313 6.22182 9.47487 6.87819C8.8185 7.53457 7.92826 7.90332 7 7.90332C6.07174 7.90332 5.1815 7.53457 4.52513 6.87819C3.86875 6.22182 3.5 5.33158 3.5 4.40332C3.5 3.47506 3.86875 2.58482 4.52513 1.92845C5.1815 1.27207 6.07174 0.90332 7 0.90332ZM7 2.65332C6.53587 2.65332 6.09075 2.83769 5.76256 3.16588C5.43437 3.49407 5.25 3.93919 5.25 4.40332C5.25 4.86745 5.43437 5.31257 5.76256 5.64076C6.09075 5.96895 6.53587 6.15332 7 6.15332C7.46413 6.15332 7.90925 5.96895 8.23744 5.64076C8.56563 5.31257 8.75 4.86745 8.75 4.40332C8.75 3.93919 8.56563 3.49407 8.23744 3.16588C7.90925 2.83769 7.46413 2.65332 7 2.65332ZM7 8.77832C9.33625 8.77832 14 9.94207 14 12.2783V14.9033H0V12.2783C0 9.94207 4.66375 8.77832 7 8.77832ZM7 10.4408C4.40125 10.4408 1.6625 11.7183 1.6625 12.2783V13.2408H12.3375V12.2783C12.3375 11.7183 9.59875 10.4408 7 10.4408Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegIcon);
export default __webpack_public_path__ + "static/media/reg-icon.df09cfa0b20c07de5e90f169f99c25e0.svg";
export { ForwardRef as ReactComponent };